export default __webpack_public_path__ + "static/media/cheers-with-zerotwo.91fc5b57.jpeg";